import { inject, Pipe, PipeTransform } from '@angular/core';
import { ThemeKey } from '../../../../../../whitelabel/theme-key.enum';
import { SidebarState } from '../contract/sidebar-state.contract';
import { ThemeService } from '../../../../../whitelabel/services/theme.service';

@Pipe({
  name: 'logoImage',
  standalone: true,
})
export class LogoImagePipe implements PipeTransform {
  private themeService = inject(ThemeService);

  public transform(theme: ThemeKey | null, sidebarState: SidebarState | null): string | null {
    const requestedTheme = theme ? this.themeService.getTheme(theme) : this.themeService.getTheme(this.themeService.getCurrentTheme());
    return (sidebarState === 'collapsed') ? requestedTheme.images.logoSmall : requestedTheme.images.logoFull;
  }
}
